(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('InsertSoopTemplateController', InsertSoopTemplateController);

    InsertSoopTemplateController.$inject = ['$controller','$sce', '$uibModalInstance', 'entity', 'AlertService', 'parameters', 'SoopkitchenUtils', 'Planning', 'PlanTypes'];

    function InsertSoopTemplateController($controller, $sce, $uibModalInstance, entity, AlertService, parameters, SoopkitchenUtils, Planning, PlanTypes) {

        var vm = this;
        var title = 'Insert a SOOP Template into Plan <span class="label label-info">'+entity.label+'</span>, Version <span\n' +
            'class="label label-info">'+entity.internalVersion+'</span>';
        angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": title, $sce: $sce, $uibModalInstance:$uibModalInstance}));
        
        /**** Properties ****/
        vm.plan = entity;
        vm.planType = parameters.planType;
        vm.anchorTime = parameters.anchorTime;
        vm.obsDefLabel = parameters.obsDefLabel;
        vm.soops = {
            "ALL" : []
        };
        vm.soopTypes = [];
        vm.selectedSoop = "";
        vm.selectedType = "ALL";
        
        //Overriding Properties from SoopkitchenDialogController:
        vm.saveDisabled = true;

        /**** Methods ****/
        //Override Methods from SoopkitchenDialogController
        vm.save = importSoopTemplate;
        vm.isValidDate = isValidDate;
        
        Planning.availableSoops(
            {
                obsDefLabel: vm.obsDefLabel
            },
            function onSuccess(data) {
                extractSoops(data, false);
            },
            {}
        );
        
        Planning.soopsInProgress(
            {
                obsDefLabel: vm.obsDefLabel
            },
            function onSuccess(data) {
                extractSoops(data, true);
            },{}
        );

        vm.soops.ALL.sort();
        vm.soopTypes.splice(0, 0, "ALL");
        
        function extractSoops(data, inProgress) {
            var cleanData = angular.fromJson(angular.toJson(data));
            for (var type in cleanData) {
                if (!vm.soops.hasOwnProperty(type)) {
                    vm.soops[type] = [];
                }
                for (var i = 0; i < cleanData[type].length; i++) {
                    var soop = cleanData[type][i];
                    if (inProgress) {
                        soop += " (not baselined)";
                    }
                    var soopObject = {
                        label: soop,
                        disabled: inProgress
                    };
                    if (!vm.soopTypes.includes(type)) {
                        vm.soopTypes.push(type);
                    }
                    vm.soops[type].push(soopObject);
                    vm.soops.ALL.push(soopObject);
                }
            }
        }
        
        
        function isValidDate(date) {
            if (date === null || date === '') {
                vm.saveDisabled = true;
                return false;
            }
            vm.saveDisabled = vm.selectedSoop ==='' || (false === SoopkitchenUtils.isValidDate(date));
            return SoopkitchenUtils.isValidDate(date);
        }
        
        function importSoopTemplate() {
            var time = vm.anchorTime;
            Planning.importSoop(
                {
                    planType: vm.planType,
                    planLabel: vm.plan.label,
                    importLabel: vm.selectedSoop.label,
                    anchorDate: time
                },
                function successCallback(data) {
                    SoopkitchenUtils.updatePlanFromDialog(data);
                    $uibModalInstance.dismiss('cancel');

                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            );
        }
    }
})();
